import React from 'react';
import { STATUS_COLORS, fmtDate } from '../lib/format';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Loader2, AlertTriangle } from 'lucide-react';

/** Intelligent duplicate protection popup: Cancel vs Confirm & Add Anyway. */
export const DuplicateAlertDialog = ({ matches, saving, onCancel, onConfirm }) => (
  <Dialog open={!!matches} onOpenChange={(o) => !o && onCancel()}>
    <DialogContent className="max-w-md" data-testid="duplicate-alert-dialog">
      <DialogHeader>
        <DialogTitle className="font-heading flex items-center gap-2">
          <AlertTriangle size={17} className="text-amber-500" /> Possible Duplicate Lead
        </DialogTitle>
        <DialogDescription>
          A lead with the same name, mobile number or brand already exists. Add anyway?
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-1.5 max-h-[220px] overflow-y-auto" data-testid="duplicate-matches-list">
        {(matches || []).map((m) => (
          <div key={m.id} className="flex items-center justify-between rounded-lg border bg-muted/40 px-3 py-2" data-testid={`duplicate-match-${m.id}`}>
            <div className="min-w-0">
              <div className="text-sm font-medium truncate">{m.lead_name}{m.company_name ? ` · ${m.company_name}` : ''}</div>
              <div className="text-xs text-muted-foreground">{m.phone || 'no phone'} · added {fmtDate(m.date_created)}</div>
            </div>
            <Badge variant="outline" className={`ml-2 text-[10px] shrink-0 ${STATUS_COLORS[m.status] || ''}`}>{m.status}</Badge>
          </div>
        ))}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={onCancel} data-testid="duplicate-cancel-button">Cancel</Button>
        <Button onClick={onConfirm} disabled={saving} className="bg-amber-600 hover:bg-amber-700 text-white" data-testid="duplicate-confirm-button">
          {saving ? <Loader2 className="animate-spin" size={15} /> : 'Confirm & Add Anyway'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
